<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box margin-bottom20">
          <h2 class="history_box-head flex_center_between_box">Data Analysis</h2>
          <div class="flex_center_between_box">
            <ul class="flex_center Data-Management-ul">
              <li v-for="(item, index) in managementMenu" @click="MenuClick(item)"
                :class="menuActive == item.value ? 'menuActiveColor font18 font_bold' : 'font18'" :key="index">{{ item.label
                }}</li>
            </ul>
           
           
          </div>
            <ul class="flex_between_box">
                <li class="DataAnaLysis-Nine-grid">
                    <p>Number of selected enterprises</p>
                    <p class="font1290C9">100</p>
                </li>
                 <li class="DataAnaLysis-Nine-grid">
                    <p>Number of selected enterprise industries</p>
                    <p class="font1290C9">100</p>
                </li>
                 <li class="DataAnaLysis-Nine-grid">
                    <p>The country where the selected enterprise</p>
                    <p class="font1290C9">100</p>
                </li>

                 <li class="DataAnaLysis-Nine-grid">
                    <p>Industry Prospects </p>
                    <p class="flex_between_box"><span class="font1290C9">Good 4</span><span class="font1290C9">Average 2</span><span class="font1290C9">Poor 2</span><span class="font1290C9">Unknown 2</span></p>
                </li>
            </ul>

        </div>
        <industryAnalysis v-if="menuActive == 1 && iconactive2 == 'table'" :isOpenSlct="isOpenSlct"  :Compare="Compare" :FilterObj="FilterObj" ></industryAnalysis>
        <EnterpriseAnaiysis v-if="menuActive == 2" :isOpenSlct="isOpenSlct" refs="Companiesviewed" :Compare="Compare" ></EnterpriseAnaiysis>
      
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import ReLogin from "../../../components/ReLogin.vue";
import Page from '@/components/page/index.vue';
import industryAnalysis from "./AnalysisCompents/industryAnalysis.vue";
import EnterpriseAnaiysis from "./AnalysisCompents/EnterpriseAnaiysis.vue";
import { getTabListOneLayerForAccount } from "@/api/companyApi";
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
    Page,
    industryAnalysis,
    EnterpriseAnaiysis,
  },
  watch:{
  FilterObj: {
            handler(newVal, oldVal) {
                // 在这里处理columns属性的变化
              this.FilterObj=newVal
                // 这里可以进行一些逻辑处理或者触发其他操作
            },
            powerArr:[],
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
  },
  data() {
    return {
      reLoginVis: false,
      isOpenSlct: false,
      Compare:false,
      FilterObj:{
        companyIsicEn:'',
        companyName:'',
        companyStatusEn:'',
        companyTypeEn:"",
        endTime:'',
        startTime:'',
      },
      iconactive2: 'table',
      menuActive: 1,

      window: window,
     
      managementMenu: [
        {
          label: 'Industry Analysis',
          value: '1'
        },
        {
          label: 'Enterprise Analysis',
          value: '2'
        },
     
      ]
    };
  },
  beforeDestroy() { },
  destroyed() { },
  mounted() {
    this.getTabListOneLayerForAccountlist()
    if (this.$route.query.type) {
      this.menuActive = this.$route.query.type
    }
    if(this.$route.query.type!=1){
           this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: false,
            });
    }else{
        this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
    }
  },

  methods: {
     setToolsfalse() {
      this.$store.dispatch("app/setTools", {

        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {

        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {

        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "print",
        key: "isActive",
        value: false,
      });
    },
    getTabListOneLayerForAccountlist(){
      getTabListOneLayerForAccount({
        moduleId:507
      }).then(res=>{
        if(res.code==200){
          this.powerArr=res.data
        }
      })
    },
    clickIcon(value) {

      if( this.powerArr[1].hasPrivilege){
  
      if(value=='table'){
   this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
          this.$store.dispatch("app/toggleMenu", false);
      }else{
         this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: false,
            });
                 this.$store.dispatch("app/setTools", {
                name: "riskScanning",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "customPortfolio",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });
          this.$store.dispatch("app/toggleMenu", true);
      }
          this.iconactive2 = value
      

      }else{
      this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');

      }

    },
    MenuClick(item) {
      if(item.value<=3 || this.powerArr[5].hasPrivilege){
              if(item.value==1){
         this.iconactive2 = 'table'
       this.$store.dispatch("app/setTools", {

                name: "menu",
                key: "isActive",
                value: true,
            });
      }else{
          
            this.$store.dispatch("app/setTools", {
                name: "menu",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/toggleMenu", true);
      }
      this.menuActive = item.value
      this.$router.push({
        query: {

          type: item.value       // 修改或添加type参数
        }
      })


      }else{
        this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！');

      }
     
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList", []);   
              this.$store.dispatch("app/setTools", {
                name: "riskScanning",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "customPortfolio",
                key: "isActive",
                value: false,
            });
                this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });

    },





  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1A2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

@media screen and (max-width: 1441px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #F5F5F5;
  border-radius: 4px;
  width: max-content;
  margin: auto;

}

.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}




.icon {
  margin: 0 1.4285714285714286rem;
}
.DataAnaLysis-Nine-grid{
background: #FFFFFF;
border-radius: 4px;
border: 1px solid #A2A9B0;
padding: 10px 20px;
text-align: center;
width: 24.4%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>